export const FETCH_NOTES = "FETCH_NOTES";
export const SELECT_NOTE = "SELECT_NOTE";
export const NEW_NOTE = "NEW_NOTE";
export const DELETE_NOTE = "DELETE_NOTE";
export const TITLE_UPDATE = "TITLE_UPDATE";
export const CONTENT_UPDATE = "CONTENT_UPDATE";

export const AUTH_LOGIN = "AUTH_LOGIN";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const AUTH_ERROR = "AUTH_ERROR";
export const CLEAR_ERROR = "CLEAR_ERROR";
